var React = require('react');

function ToolsKitchenServingDome (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"tools-kitchen-serving-dome"),React.createElement("path",{"d":"M23,17.375H1a1,1,0,0,0,0,2H2.061a1,1,0,0,1,.832.445l.443.664A2,2,0,0,0,5,21.375H19a2,2,0,0,0,1.664-.891l.443-.664a1,1,0,0,1,.832-.445H23a1,1,0,0,0,0-2Z","key":1}),React.createElement("path",{"d":"M3,15.875H21a.5.5,0,0,0,.5-.5,9.517,9.517,0,0,0-7.276-9.237.251.251,0,0,1-.17-.346,2.228,2.228,0,0,0,.2-.917,2.25,2.25,0,0,0-4.5,0,2.228,2.228,0,0,0,.2.917.251.251,0,0,1-.17.346A9.517,9.517,0,0,0,2.5,15.375.5.5,0,0,0,3,15.875ZM6.464,9.952A7.774,7.774,0,0,1,10.894,7.7a.75.75,0,1,1,.212,1.484A6.279,6.279,0,0,0,7.535,11,.75.75,0,1,1,6.464,9.952Z","key":2})]);
}

ToolsKitchenServingDome.defaultProps = {"id":"Bold","viewBox":"0 0 24 24"};

module.exports = ToolsKitchenServingDome;

ToolsKitchenServingDome.default = ToolsKitchenServingDome;
